import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../api/firebase";
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Rate = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // 'loading' | 'success' | 'error'
  const [score, setScore] = useState(null);

  useEffect(() => {
    const ddpId = searchParams.get("ddpId");
    const scoreParam = searchParams.get("score");

    if (!ddpId || !scoreParam) {
      setStatus("error");
      return;
    }

    const numericScore = parseInt(scoreParam, 10);
    if (isNaN(numericScore) || numericScore < 1 || numericScore > 5) {
      setStatus("error");
      return;
    }

    setScore(numericScore);

    const processRating = async () => {
      try {
        const ref = doc(db, "ReiNoInori", ddpId);
        const docSnap = await getDoc(ref);

        if (!docSnap.exists()) {
          setStatus("error");
          return;
        }

        const data = docSnap.data();

        if (data.rating) {
          setStatus("already");
          return;
        }

        // 🌐 IPアドレス取得
        const ipRes = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipRes.json();
        const userIp = ipData.ip || "unknown";

        // Firestoreに保存
        await updateDoc(ref, {
          rating: numericScore,
          ratedAt: new Date(),
          ratedIp: userIp,
        });

        setStatus("success");
      } catch (err) {
        console.error("エラー:", err);
        setStatus("error");
      }
    };

    processRating();
  }, [searchParams]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: "center" }}>
      {status === "loading" && (
        <>
          <CircularProgress />
          <Typography mt={2}>評価を送信中です...</Typography>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircleIcon sx={{ fontSize: 60, color: "green" }} />
          <Typography variant="h5" mt={2}>
            ご協力ありがとうございました！
          </Typography>
          <Typography mt={1}>
            あなたの評価（★{score}）を記録しました。
          </Typography>
        </>
      )}
      {status === "already" && (
        <>
          <CheckCircleIcon sx={{ fontSize: 60, color: "#ff9800" }} />
          <Typography variant="h5" mt={2}>
            こちらは既に評価済です。
          </Typography>
          <Typography mt={1}>ご協力ありがとうございます！</Typography>
        </>
      )}
      {status === "error" && (
        <>
          <Typography variant="h6" color="error">
            リンクが無効または処理中にエラーが発生しました。
          </Typography>
          <Button variant="outlined" href="/" sx={{ mt: 2 }}>
            トップページに戻る
          </Button>
        </>
      )}
    </Container>
  );
};

export default Rate;
